import { render, staticRenderFns } from "./RestartServer.vue?vue&type=template&id=fda5c49c&scoped=true&"
import script from "./RestartServer.vue?vue&type=script&lang=ts&"
export * from "./RestartServer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda5c49c",
  null
  
)

export default component.exports